<template>
  <div class="account-settings">
    <v-col cols="12" class="px-0">
      <v-row>
        <v-col cols="12" md="12">
          <v-card class="pa-3">
            <v-card-title>گزارش خطا</v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <div class="warning-div w-100 pa-4 text-center">
                    <h4>
                      لطفا در صورتی که خطایی در سامانه مشاهده کرده‌اید، با پر
                      کردن فرم زیر ما را در برطرف کردن آن یاری کنید. لطفا توجه
                      بفرمایید که هر چه اطلاعات کاملتری در اختیار ما بگذارید،
                      خطای گزارش شده سریع‌تر و کامل‌تر بررسی و رفع خواهد شد.
                    </h4>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <h4 class="mb-2">عنوان خطا</h4>
                  <v-text-field
                    outlined
                    dense
                    hide-details
                    color="#444"
                    v-model="bug.title"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <h4 class="mb-2">توضیحات</h4>
                  <vue-ckeditor v-model="bug.description" :config="config" />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <h4 class="mb-2">
                    اختیاری: لطفا لینک صفحه‌ای که خطا را در آن مشاهده کردید وارد
                    کنید.
                  </h4>
                  <v-text-field
                    outlined
                    dense
                    hide-details
                    color="#444"
                    v-model="bug.url"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mb-2 mt-6">
                <v-col
                  class="d-flex flex-sm-row flex-column justify-space-between"
                >
                  <v-btn
                    class="primary white--text mx-sm-0 mx-auto mb-sm-0 mb-4"
                    @click="submitBug()"
                    :loading="submitBusy"
                    :disabled="!bug.title || !bug.description"
                  >
                    <v-icon class="me-1">mdi-check-bold</v-icon>
                    ثبت خطا
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import { SpringSpinner } from "epic-spinners";
import VueCkeditor from "vue-ckeditor2";

export default {
  components: {
    SpringSpinner,
    VueCkeditor,
  },
  data() {
    return {
      role: "",
      submitBusy: false,
      bug: {
        title: "",
        description: "",
        url: "",
      },
      config: {
        language: "fa",
        contentsLangDirection: "rtl",
        toolbar: [
          {
            name: "clipboard",
            items: [
              "Cut",
              "Copy",
              "Paste",
              "PasteText",
              "PasteFromWord",
              "-",
              "Undo",
              "Redo",
            ],
          },
          {
            name: "editing",
            items: ["Find", "Replace", "-", "SelectAll"],
          },
          "/",
          {
            name: "basicstyles",
            items: [
              "Bold",
              "Italic",
              "Underline",
              "Strike",
              "Subscript",
              "Superscript",
              "-",
              "CopyFormatting",
              "RemoveFormat",
            ],
          },
          {
            name: "paragraph",
            items: [
              "NumberedList",
              "BulletedList",
              "-",
              "Outdent",
              "Indent",
              "-",
              "Blockquote",
              "CreateDiv",
              "-",
              "JustifyLeft",
              "JustifyCenter",
              "JustifyRight",
              "JustifyBlock",
              "-",
              "BidiLtr",
              "BidiRtl",
            ],
          },
          { name: "links", items: ["Link", "Unlink", "Anchor"] },

          "/",
          { name: "styles", items: ["Styles", "Format", "Font", "FontSize"] },
          { name: "colors", items: ["TextColor", "BGColor"] },
          { name: "tools", items: ["Maximize", "ShowBlocks"] },
        ],
        height: 200,
      },
    };
  },
  methods: {
    submitBug() {
      this.submitBusy = true;
      this.$http
        .post(
          this.baseUrl + "/user/submitBug",
          {
            title: this.bug.title,
            description: this.bug.description,
            url: this.bug.url,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.submitBusy = false;
            this.bug = {
              title: "",
              description: "",
              url: "",
            };
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
            this.submitBusy = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.submitBusy = false;
        });
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
.v-tabs-bar__content {
  width: 100% !important;
}
</style>
